import { SET_BUNKEY_HOST, CLOSE_BUNKEY_HOST } from "../constants/bunkey-host-types"


export const closeBunkeyHost = () => {
    return (dispatch) => {

        dispatch({ type: CLOSE_BUNKEY_HOST })
    }
}

export const setBunkeyHost = (asset) => {
    return (dispatch) => {
        dispatch({ type: SET_BUNKEY_HOST, payload: { asset: asset } })
    }
}